/* tslint:disable */
/* eslint-disable */
/**
 * Bank API Schema
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * 
 * @export
 * @interface GetPaymentRequestEvidences200ResponseInnerErrors
 */
export interface GetPaymentRequestEvidences200ResponseInnerErrors {
    /**
     * 
     * @type {string}
     * @memberof GetPaymentRequestEvidences200ResponseInnerErrors
     */
    'detectedDpi'?: GetPaymentRequestEvidences200ResponseInnerErrorsDetectedDpiEnum;
    /**
     * 
     * @type {string}
     * @memberof GetPaymentRequestEvidences200ResponseInnerErrors
     */
    'calculatedDpi'?: GetPaymentRequestEvidences200ResponseInnerErrorsCalculatedDpiEnum;
    /**
     * 
     * @type {string}
     * @memberof GetPaymentRequestEvidences200ResponseInnerErrors
     */
    'colorGradation'?: GetPaymentRequestEvidences200ResponseInnerErrorsColorGradationEnum;
    /**
     * 
     * @type {string}
     * @memberof GetPaymentRequestEvidences200ResponseInnerErrors
     */
    'heightMillis'?: GetPaymentRequestEvidences200ResponseInnerErrorsHeightMillisEnum;
    /**
     * 
     * @type {string}
     * @memberof GetPaymentRequestEvidences200ResponseInnerErrors
     */
    'widthMillis'?: GetPaymentRequestEvidences200ResponseInnerErrorsWidthMillisEnum;
}

export const GetPaymentRequestEvidences200ResponseInnerErrorsDetectedDpiEnum = {
    insufficient: 'INSUFFICIENT',
    unknown: 'UNKNOWN'
} as const;

export type GetPaymentRequestEvidences200ResponseInnerErrorsDetectedDpiEnum = typeof GetPaymentRequestEvidences200ResponseInnerErrorsDetectedDpiEnum[keyof typeof GetPaymentRequestEvidences200ResponseInnerErrorsDetectedDpiEnum];
export const GetPaymentRequestEvidences200ResponseInnerErrorsCalculatedDpiEnum = {
    pixelsInsufficient: 'PIXELS_INSUFFICIENT',
    pixelsRequired: 'PIXELS_REQUIRED',
    realSizeRequired: 'REAL_SIZE_REQUIRED',
    insufficient: 'INSUFFICIENT',
    unknown: 'UNKNOWN'
} as const;

export type GetPaymentRequestEvidences200ResponseInnerErrorsCalculatedDpiEnum = typeof GetPaymentRequestEvidences200ResponseInnerErrorsCalculatedDpiEnum[keyof typeof GetPaymentRequestEvidences200ResponseInnerErrorsCalculatedDpiEnum];
export const GetPaymentRequestEvidences200ResponseInnerErrorsColorGradationEnum = {
    required: 'REQUIRED',
    insufficient: 'INSUFFICIENT'
} as const;

export type GetPaymentRequestEvidences200ResponseInnerErrorsColorGradationEnum = typeof GetPaymentRequestEvidences200ResponseInnerErrorsColorGradationEnum[keyof typeof GetPaymentRequestEvidences200ResponseInnerErrorsColorGradationEnum];
export const GetPaymentRequestEvidences200ResponseInnerErrorsHeightMillisEnum = {
    required: 'REQUIRED'
} as const;

export type GetPaymentRequestEvidences200ResponseInnerErrorsHeightMillisEnum = typeof GetPaymentRequestEvidences200ResponseInnerErrorsHeightMillisEnum[keyof typeof GetPaymentRequestEvidences200ResponseInnerErrorsHeightMillisEnum];
export const GetPaymentRequestEvidences200ResponseInnerErrorsWidthMillisEnum = {
    required: 'REQUIRED'
} as const;

export type GetPaymentRequestEvidences200ResponseInnerErrorsWidthMillisEnum = typeof GetPaymentRequestEvidences200ResponseInnerErrorsWidthMillisEnum[keyof typeof GetPaymentRequestEvidences200ResponseInnerErrorsWidthMillisEnum];


